export const blue = '#75DAFA';
export const green = '#65A637';
export const green25 = '#D8E8CC';
export const green50 = '#b2d29b';
export const green75 = '#8BBC69';
export const yellow = '#f2aa00';
export const grey = '#d8d8d8';




// WEBPACK FOOTER //
// ./src/constants/colors.js